// extracted by mini-css-extract-plugin
export default {"progressBar":"ApplyHeader_progressBar__xWDQ5"};